import { BrowserRouter, HashRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";

import "./App.css";
import Header from "./component/header";
import Footer from "./component/footer";
import ScrollToTop from "./component/ScrollToTop";

const Router = process.env.REACT_APP_PRERENDER ? HashRouter : BrowserRouter;

// Lazy-loaded pages
const Home2 = lazy(() => import("./pages/home2"));
const About = lazy(() => import("./pages/about"));
const ProductList = lazy(() => import("./pages/productlist"));
const ProductDetail = lazy(() => import("./pages/productDetail"));
const Contact = lazy(() => import("./pages/contact"));
const Blog = lazy(() => import("./pages/blog"));
const BlogDetail = lazy(() => import("./pages/blog-detail"));
const TermsConditions = lazy(() => import("./pages/teams"));

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />

      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<Home2 />} />
          <Route path="/term" element={<TermsConditions />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />

          <Route path="/blog" element={<Blog />} />
          <Route path="/blogdetail/:title" element={<BlogDetail />} />

          <Route path="/productlist" element={<ProductList />} />
          <Route path="/productdetail/:skuId" element={<ProductDetail />} />
        </Routes>
      </Suspense>

      <Footer />
    </Router>
  );
}

export default App;